angular
    .module('quattro.bmbo.account.model', [
        'quattro.core.model.prototype',
        'quattro.core.hpls_api_1',
    ])
    .factory('Account', function ($log, Model, api) {

        var prototype = Model.prototype;

        // clarify internal naming here
        function getDefaultData() {
            return {
                // primary key
                account: undefined,

                password: undefined,
                plan: undefined,
                memo: undefined,

                address_payment_same_as_main: true,
                max_mailinglist: 5,
            };
        }


        var authorization = {
            read: 'all',
            create: ['admin'],
            update: {
                default: ['admin', 'account'],
                attributes: {
                    plan: ['admin', 'account'],
                }
            },
            remove: ['admin'],
        };

        var scenarios = {
            read: [
                {
                    method: 'account.get',
                    params: {
                        account: {
                            primary_key: true,
                        },
                    },
                    results: {
                        account: null,
                        type: null,
                        status: null,
                        plan: null,

                        company: null,
                        ustid: null,
                        address_main_first_name: 'address_main.first_name',
                        address_main_last_name: 'address_main.last_name',
                        address_main_street: 'address_main.street',
                        address_main_zipcode: 'address_main.zipcode',
                        address_main_town: 'address_main.town',
                        address_main_country: 'address_main.country',
                        bank: null,
                        max_mailinglist: null,
                        tarifflimits: null,
                        contact_mail: 'contact.mail',
                        contact_mail_payment: 'contact.mail_payment',
                        contact_phone: 'contact.phone',
                        contact_fax: 'contact.fax',
                        contact_mobile: 'contact.mobile',
                        memo: null,
                        monthly_fee: {
                            filter: prototype.filter.strToInt,
                        },
                        invoice_type: null,
                        payment_type: null,
                        bank_iban: 'bank.iban',
                        bank_bic: 'bank.bic',
                        bank_account_owner: 'bank.account_owner',
                        bank_name: 'bank.name',
                        address_payment_same_as_main: 'address_payment.same_as_main',
                        address_payment_first_name: 'address_payment.first_name',
                        address_payment_last_name: 'address_payment.last_name',
                        address_payment_company: 'address_payment.company',
                        address_payment_street: 'address_payment.street',
                        address_payment_zipcode: 'address_payment.zipcode',
                        address_payment_town: 'address_payment.town',
                        address_payment_country: 'address_payment.country',
                        av_contract_signed: 'av_contract.signed',
                        av_contract_info_date: 'av_contract.info.date',
                        av_contract_accept_name: 'av_contract.info.name',
                        av_contract_info_version: 'av_contract.info.version',
                        av_contract_professional_secrecy: 'av_contract.professional_secrecy',
                        dta_allowed: null,
                        end_date: null,
                    }
                },
            ],
            create: [
                {
                    method: 'account.add',
                    params: {
                        account: true,
                        password: true,
                        plan: true,
                        memo: null,
                        contact_mail: null,
                        contact_phone: true,
                        contact_fax: null,
                        contact_mobile: null,
                        company: true,
                        ustid: null,
                        address_main_first_name: true,
                        address_main_last_name: true,
                        address_main_street: true,
                        address_main_zipcode: true,
                        address_main_town: true,
                        address_main_country: null,
                        address_payment_same_as_main: {
                            always_send: true,
                        },
                        address_payment_first_name: null,
                        address_payment_last_name: null,
                        address_payment_company: null,
                        address_payment_street: null,
                        address_payment_zipcode: null,
                        address_payment_town: null,
                        address_payment_country: null,
                        max_mailinglist: null,
                        tarifflimits: null
                    },
                },
            ],
            update: [
                {
                    method: 'account.set',
                    params: {
                        account: {
                            primary_key: true,
                        },
                        password: null,
                        plan: null,
                        memo: null,
                        contact_mail: null,
                        contact_mail_payment: null,
                        contact_phone: true,
                        contact_fax: null,
                        contact_mobile: null,
                        company: true,
                        ustid: null,
                        tarifflimits: null,
                        address_main_first_name: true,
                        address_main_last_name: true,
                        address_main_street: true,
                        address_main_zipcode: true,
                        address_main_town: null,
                        address_main_country: null,
                        address_payment_same_as_main: null,
                        address_payment_first_name: null,
                        address_payment_last_name: null,
                        address_payment_company: null,
                        address_payment_street: null,
                        address_payment_zipcode: null,
                        address_payment_town: null,
                        address_payment_country: null,
                        av_contract_accept_name: null,
                        av_contract_professional_secrecy: null,
                        av_contract_info_version: {
                            always_send: true,
                        },
                        payment_type: null,
                        bank_iban: true,
                        bank_bic: true,
                        bank_account_owner: true,
                        bank_name: true,
                        max_mailinglist: null
                    },
                },
            ],
            remove: [
                {
                    method: 'account.del',
                    params: {
                        account: {
                            primary_key: true,
                        },
                    },
                },
            ],
        };


        function Account(config, scenario) {
            this.scenario = scenario;
            var data = scenario === 'create' ? getDefaultData() : {};
            this.data = angular.merge(data, config);
            this.data.$validate = this.validate.bind(this);
            this.data.$isDirty = this.isDirty.bind(this);
        }

        Account.prototype = angular.merge(new Model(), {
            scenarios: scenarios,
            authorization: authorization,
        });

        Account.cancel = function (account, date) {
            if (!date) {
                date = new Date();
                // end of next month
                date = new Date(date.getFullYear(), date.getMonth() + 2, 0);
                var month = date.getMonth() + 1;    // `getMonth` is zero-indexed
                date = [
                    date.getFullYear(),
                    month < 10 ? '0' + month : month,
                    date.getDate(),
                ].join('-');
            }
            var promise = api.single('account.cancel', {
                account: account,
                enddate: date,
            });
            promise.then(null, function (error) {
                $log.error('account.cancel', error.code, error.message);
            });
            return promise;
        };

        Account.revokeCancel = function (account) {
            var promise = api.single('account.cancel', {
                account: account,
                revoke: true,
            });
            promise.then(null, function (error) {
                $log.error('account.cancel revoke', error.code, error.message);
            });
            return promise;
        };

        return Account;
    });
